import axiosInstance from './axios-instance';
import { resolveOwnerScopedAccountId } from '../helper/accountScope';
import { isMutationSuccess } from './cache-utils';
import { invalidateProjectDataCache, resolveClientId } from './cache-invalidation';

const withScopedAccountId = (payload: any) => ({
  ...payload,
  accountId: resolveOwnerScopedAccountId(payload?.accountId),
});

const getAllEstimates = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`estimates/get-all`, withScopedAccountId(payload));
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getEstimateBuilderContext = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`estimates/context`, withScopedAccountId(payload));
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getEstimatePreviewShared = async (id: number) => {
  try {
    const response = await axiosInstance.get(`estimates/public/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getEstimatePreview = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`estimates/preview`, withScopedAccountId(payload));
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getEstimateByPublicId = async (publicId: string) => {
  try {
    const response = await axiosInstance.get(`estimates/public/${encodeURIComponent(publicId)}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const saveEstimate = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.post(`estimates/save`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(scopedPayload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const updateEstimate = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.put(`estimates/update`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(scopedPayload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const sendEstimate = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.post(`estimates/send`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(scopedPayload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const deleteEstimate = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.post(`estimates/delete`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(scopedPayload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const downloadEstimatePdf = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `estimates/download-pdf`,
      withScopedAccountId(payload),
    );

    return response.data
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export {
  deleteEstimate,
  getAllEstimates,
  getEstimateBuilderContext,
  getEstimateByPublicId,
  getEstimatePreview,
  saveEstimate,
  sendEstimate,
  updateEstimate,
  getEstimatePreviewShared,
  downloadEstimatePdf,
};
